export default __webpack_public_path__ + "static/media/ic_marker_canal.68e6da55.svg";